import {Route, Routes} from "react-router-dom";
import {publicRoutes} from "./routes/";
import "./assets/sass/style.scss";
import Layout from './components/layout';
import {connect} from "react-redux";
import {getCurrentUser} from "./store/auth/actions";
import {getCategoryList} from "./store/categories/actions";
import {getFeaturedProductList, getLatestProductList, getProductList} from "./store/products/actions";
import {getSliderData} from "./store/slider/actions";
import {Helmet} from "react-helmet";
import {getBlogList} from "./store/blog/actions";
import {getPartnersList} from "./store/partners/actions";
import useEffectOnce from "./utils/hooks/useEffectOnce";
import {getCurrency} from "./store/currency/actions";

function App({
                 auth,
                 getCurrentUser,
                 getSliderData,
                 getCategoryList,
                 getFeaturedProductList,
                 getLatestProductList,
                 getBlogList,
                 getPartnersList,
                 getCurrency
             }) {
    useEffectOnce(() => {
        getSliderData();
        getCategoryList();
        getPartnersList();
        getBlogList();
        getCurrency();

        if (auth.token && auth.user === null) {
            getCurrentUser();
        } else {
            getFeaturedProductList();
            getLatestProductList();
        }
    })

    const renderHeaderMeta = () => {
        return (
            <Helmet>
                <title>SSD - Sisteme Sigurie, Kamera CCTV & Alarme Tiranë</title>
            </Helmet>
        )
    }

    return (
        <div className="App">
            {renderHeaderMeta()}
            <Routes>
                <Route element={<Layout/>}>
                    {publicRoutes.map((route, idx) => (
                        <Route path={route.path} element={route.component} key={idx}>
                            {route.children?.map((childRoute, childIdx) => (
                                <Route path={childRoute.path} element={childRoute.component} key={childIdx}/>
                            ))}
                        </Route>
                    ))}
                </Route>
            </Routes>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    }
}

const mapDispatchToProps = {
    getCurrentUser,
    getSliderData,
    getCategoryList,
    getProductList,
    getFeaturedProductList,
    getLatestProductList,
    getBlogList,
    getPartnersList,
    getCurrency
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
